import { SIJI_DATA } from '@entities/saju'
import { cn } from '@shared/lib/cn'
import { Button } from '@shared/ui/button'
import { HeroLayout } from '@shared/ui/hero-layout'

interface Step3TimeProps {
  readonly birthTime: string
  readonly onBirthTimeChange: (v: string) => void
  readonly onBack: () => void
  readonly onNext: () => void
}

export function Step3Time({ birthTime, onBirthTimeChange, onBack, onNext }: Step3TimeProps) {
  const handleSelect = (value: string) => {
    if (birthTime === value) {
      onBirthTimeChange('')
      return
    }
    onBirthTimeChange(value)
  }

  return (
    <HeroLayout
      characterImage="/character-assets/4_check_birth_time_cleaned.png"
      progressStep={3}
      title="태어난 시간을 알려주세요"
      subtitle="몰라도 괜찮아요, 건너뛸 수 있어요"
      onBack={onBack}
      gradientStop="70%"
      footer={
        <div className="flex gap-2">
          <Button
            type="button"
            variant="outline"
            size="lg"
            className="flex-1"
            onClick={() => {
              onBirthTimeChange('')
              onNext()
            }}
          >
            잘 모르겠어요
          </Button>
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="flex-[2]"
            disabled={!birthTime}
            onClick={onNext}
          >
            다음
          </Button>
        </div>
      }
    >
      {/* 4x3 그리드: 시간 범위 1차 + 시진명 보조 */}
      <div className="grid grid-cols-4 gap-1.5">
        {SIJI_DATA.map((siji) => {
          const isSelected = birthTime === siji.value
          return (
            <button
              key={siji.value}
              type="button"
              className={cn(
                'flex cursor-pointer flex-col items-center justify-center gap-0.5 rounded-xl py-2.5 transition-all',
                isSelected
                  ? 'border border-primary bg-primary/10 text-foreground'
                  : 'border border-border bg-bg-surface text-muted-foreground hover:bg-bg-surface-hover',
              )}
              onClick={() => {
                handleSelect(siji.value)
              }}
            >
              <span className="typo-caption font-semibold">{siji.range}</span>
              <span
                className={cn(
                  'typo-footnote',
                  isSelected ? 'text-primary' : 'text-muted-foreground/60',
                )}
              >
                {siji.name}
              </span>
            </button>
          )
        })}
      </div>
    </HeroLayout>
  )
}
